import big from "../assets/services/big.png";
import nosql from "../assets/services/nosql.png";
import web from "../assets/services/web.jpg";
import badminton from "../assets/services/badminton.jpg";
import app from "../assets/services/app.jpg";
export const services = [
  { img: big, name: "BigData & Cloud", id: 1 },
  { img: nosql, name: "NoSQL Services", id: 2 },
  { img: web, name: "Apps & Web Development", id: 3 },
  { img: app, name: "Application Development", id: 4 },
];
